/**
 * Utility for managing Instagram scraping via Web Worker
 */

export interface ScrapeResult {
    success: boolean;
    caption?: string;
    url: string;
    error?: string;
}

// Valid Instagram URL patterns
const INSTAGRAM_PATTERNS = [
    /^https?:\/\/(www\.)?instagram\.com\/p\/[\w-]+/,
    /^https?:\/\/(www\.)?instagram\.com\/reel\/[\w-]+/,
    /^https?:\/\/(www\.)?instagram\.com\/reels\/[\w-]+/,
    /^https?:\/\/(www\.)?instagram\.com\/tv\/[\w-]+/,
];

export function isValidInstagramUrl(url: string): boolean {
    const trimmed = url.trim();
    if (!trimmed) return false;
    return INSTAGRAM_PATTERNS.some(pattern => pattern.test(trimmed));
}

const worker = new Worker("/workers/scraper.worker.js", {
    type: "module",
});

worker.onerror = (e) => {
    console.error("Scraper Worker Error:", e);
};

const pendingRequests = new Map<string, (res: ScrapeResult) => void>();

worker.onmessage = (e) => {
    const result = e.data as ScrapeResult;
    const resolver = pendingRequests.get(result.url);
    if (resolver) {
        resolver(result);
        pendingRequests.delete(result.url);
    }
};

export function scrapeCaption(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
        pendingRequests.set(url, (res) => {
            if (res.success && res.caption) {
                resolve(res.caption);
            } else {
                reject(new Error(res.error || "Failed to extract caption"));
            }
        });
        worker.postMessage({ url });
    });
}
